import { shallowEqual } from 'react-redux';
import { CSSEditorIsBusy } from '../style';
import { Widget } from 'jamespot-front-business';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppSelector } from '../../../redux/store';

const Loader = commonComponentsRegistry.getLazyComponent('Loader');

export const EditorIsBusy = ({ uniqid }: { uniqid: string }) => {
    const isBusy = useAppSelector((state) => Widget.selectors.selectWidgetState(state, uniqid), shallowEqual)?.busy;
    return (
        <>
            {isBusy && (
                <CSSEditorIsBusy>
                    <Loader size={'l'} />
                </CSSEditorIsBusy>
            )}
        </>
    );
};
